import { onMounted, onUnmounted, ref } from 'vue'
import type { Ref } from 'vue-demi'

interface Options {
  parentRef?: Ref<HTMLElement | undefined>
  intersectionRef: Ref<HTMLElement | undefined>
  scrollPaddingFetch?: number
  onIntersection: () => void
}

export const useIntersectionRef = (options: Options) => {
  const { parentRef, intersectionRef, scrollPaddingFetch = 0, onIntersection } = options

  const observer = ref<IntersectionObserver>()

  const initObserver = () => {
    if (!intersectionRef.value) {
      return
    }

    observer.value = new IntersectionObserver(
      ([container]) => {
        if (container.isIntersecting) {
          onIntersection()
        }
      },
      {
        rootMargin: `0px 0px ${scrollPaddingFetch}px 0px`,
        root: parentRef?.value
      }
    )

    observer.value.observe(intersectionRef.value)
  }

  onMounted(() => {
    initObserver()
  })

  onUnmounted(() => {
    if (observer.value) {
      observer.value.disconnect()
    }
  })
}
